import { Component, OnInit, AfterViewChecked } from '@angular/core';
import { loadStripe, Stripe, StripeElements, StripeCardElement } from '@stripe/stripe-js';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import Swal from 'sweetalert2';
import { GlobalConstants } from '../global-constants';
import { AuthService } from '../services/auth.service';

declare var $: any;

@Component({
  selector: 'app-wallet',
  templateUrl: './wallet.component.html',
  styleUrls: ['./wallet.component.less']
})
export class WalletComponent implements OnInit, AfterViewChecked {
  balance: number = 1000;
  amountToAdd: number = 0;
  showStripeForm: boolean = false;

  private stripe: Stripe | null = null;
  private elements: StripeElements | null = null;
  private cardElement: StripeCardElement | null = null;
  private cardMounted: boolean = false;

  constructor(private http: HttpClient, private authService: AuthService) {}

  async ngOnInit() {
    this.stripe = await loadStripe(GlobalConstants.Stripepkey);
    if (this.stripe) {
      this.elements = this.stripe.elements();
    }

    this.fetchCustomerDetails();
  }

  ngAfterViewChecked(): void {
    if (this.showStripeForm && !this.cardMounted && this.stripe && this.elements) {
      const cardElementDiv = document.getElementById('card-element');
      if (cardElementDiv) {
        this.cardElement = this.elements.create('card', { hidePostalCode: true });
        this.cardElement.mount('#card-element');
        this.cardMounted = true;
      }
    }
  }

  fetchCustomerDetails(): void {
    $('.preloader').show();

    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const body = {
      customer_id: this.authService.getCustomerId(),
    };

    this.http.post(GlobalConstants.apiURL + 'customerdetails', body, { headers })
      .subscribe({
        next: (response: any) => {
          this.balance = response.customer.wallet || 0;
          $('.preloader').fadeOut();
        },
        error: (error) => {
          console.error('Failed to fetch customer details:', error);
          $('.preloader').fadeOut();
        }
      });
  }

  async onStripeSubmit() {
    
    let cus_id = this.authService.getCustomerId() || '{}';
    let cus_nm = this.authService.getCustomerName() || '{}';
    
    if (!this.stripe || !this.cardElement || this.amountToAdd <= 0) {
      Swal.fire('Error', 'Invalid payment info or amount', 'error');
      return;
    }

    const { token, error } = await this.stripe.createToken(this.cardElement);

    if (error) {
      Swal.fire('Payment Error', error.message || 'Something went wrong', 'error');
      return;
    }

    console.log('Stripe token:', token);

    // Simulate API call
    // setTimeout(() => {
    //   this.balance += this.amountToAdd;
    //   this.amountToAdd = 0;
    //   this.showStripeForm = false;
    //   this.cardMounted = false; // Reset card mount flag
    //   Swal.fire('Success', 'Amount added to wallet!', 'success');
    // }, 1000);
     $('.preloader').show();
     const headers = { 'Content-type': 'application/json' };
            const body = {
              title: 'Wallet',
              customer_id: cus_id,
              customer_name: cus_nm,
              amount: this.amountToAdd,
              token: token.id,
            };
    
           this.http.post(GlobalConstants.apiURL + 'addtowallet', body, { headers })
  .subscribe(
    (response: any) => {
      $('.preloader').hide();

      if (response.status === true) {
        Swal.fire({
          title: 'Success',
          text: 'Amount added to your wallet successfully.',
          icon: 'success',
          confirmButtonText: 'OK'
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload();
          }
        });
      } else {
        Swal.fire({
          title: 'Error',
          text: response.message || 'Payment failed. Please try again.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      }
    },
    (error) => {
      $('.preloader').hide();
      Swal.fire({
        title: 'Error',
        text: 'Something went wrong. Please try again later.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
      console.error('API error:', error);
    }
  );

  }
}
